import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import { Spinner } from "react-bootstrap";
import Snackbars from "../../../utils/Snackbars";

const EventDetails = () => {
  const { e_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();
  const [detail, setDetail] = useState({
    first_name: "",
    last_name: "",
    name: "",
    city: "",
    address: "",
    start_datetime: "",
    end_datetime: "",
    status: "Enable",
    short_description: "",
    banner: "",
    general_tp: "",
    vip_tp: "",
    vvip_tp: "",
    total_tickets: ""
  });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: ""
  });

  function formatDateTime(dateString) {
    const date = new Date(dateString); // Convert to Date object

    // Extract the date components
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    // Extract the time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour format

    // Format the date and time
    return `${day}/${month}/${year}  `;
  }

  const formattedStartDate = formatDateTime(detail.start_datetime);
  const formattedEndDate = formatDateTime(detail.end_datetime);

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: ""
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [tickets, setTickets] = useState([])
  const fetchEventDetails = async () => {
    setLoading(true); // Set loading state to true
    const response = await getRequest(`event-details/${e_id}`);
    if (response && response.code === 200) {
      const data = response.data;
      setTickets(data.eventTicketTypeData)
      setDetail({
        first_name: data.first_name,
        last_name: data.last_name,
        name: data.name,
        city: data.city,
        address: data.address,
        start_datetime: data.start_datetime,
        end_datetime: data.end_datetime,
        start_time: data.start_time,
        end_time: data.end_time,
        short_description: data.short_description,
        status: data.status,
        general_tp: data.general_tp,
        vip_tp: data.vip_tp,
        vvip_tp: data.vvip_tp,
        total_tickets: data.total_tickets,
        banner: data.logo
      });
    } else {
      setAlertData({ variant: "error", message: response.message || "Failed to fetch event details" });
    }
    setLoading(false); // Set loading state to false
    resetAlertData();
  };

  useEffect(() => {
    fetchEventDetails();
  }, []);

  return (
    <Fragment>
      <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
        <h2 className="text-black font-w600 mb-0">Event Details</h2>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <Link to="/events-list" type="button" className="btn btn-rounded btn-primary">
          Back to Event
        </Link>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
          <p>Loading settings...</p>
          
        </div>
      ) : (
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="basic-form">
                <div className="row">
                  <div className="col-xl-4 col-lg-6 col-md-6 col-xxl-5">
                    <div className="tab-slide-content new-arrival-product mb-4 mb-xl-0">
                      <img src={detail.banner} alt={`${detail.name}`}  style={{ width: "100%" }} />
                      <div className="mt-4 events-bottom-details">
                        <h2 className="text-primary mb-0">{detail.name}</h2>
                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>Organizer :</span> {detail.first_name} {detail.last_name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-8 col-lg-6 col-md-6 col-xxl-7 col-sm-12">
                    <div className="product-detail-content">
                      <div className="new-arrival-content pr">                       

                        

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>City :</span> {detail.city}
                          </span>
                        </div>

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>Address : </span>
                            {detail.address}
                          </span>
                        </div>

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>Start Date | Time :</span> {formattedStartDate+""+detail.start_time}
                          </span>
                        </div>

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>End Date | Time :</span> {formattedEndDate+""+detail.end_time}
                          </span>
                        </div>

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>Description :</span> {detail.short_description}
                          </span>
                        </div>

                        <div className="comment-review star-rating">
                          <span className="review-text">
                            <span>Status :</span> <span className={detail.status=="Enable"?"text-success":"text-danger"}>{detail.status}</span>
                          </span>
                        </div>

                        {/* Group tickets by single day and date range */}
                        {(() => {
                          const singleDayTickets = tickets.filter(
                            (data) => !!data.day_date
                          );
                          const tenDayTickets = tickets.filter(
                            (data) => !data.day_date
                          );
                          return (
                            <>
                              {singleDayTickets.length > 0 && (
                                <div className="mb-2">
                                  {/* Group single day tickets by date */}
                                  {Object.entries(
                                    singleDayTickets.reduce((acc, ticket) => {
                                      if (!acc[ticket.day_date]) acc[ticket.day_date] = [];
                                      acc[ticket.day_date].push(ticket);
                                      return acc;
                                    }, {})
                                  ).map(([date, ticketsOnDate], idx) => {
                                    // Format date as DD/MM/YYYY
                                    const d = new Date(date);
                                    const day = String(d.getDate()).padStart(2, "0");
                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                    const year = d.getFullYear();
                                    const formattedDate = `${day}/${month}/${year}`;
                                    return (
                                      <div key={"date-group-" + idx} className="mb-2">
                                        <strong className="text-primary">{formattedDate}</strong>
                                        {ticketsOnDate.map((data, e) => (
                                          <div className="comment-review star-rating" key={"single-" + idx + "-" + e}>
                                            <span className="review-text">
                                              <span>
                                                {data.type} Ticket
                                              </span> Rs.{data.price}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                              {tenDayTickets.length > 0 && (
                                <div className="mb-2">
                                  <strong className="text-primary"> {formatDateTime(detail.start_datetime)} - {formatDateTime(detail.end_datetime)} ( Ten Day Tickets )</strong>
                                  {tenDayTickets.map((data, e) => (
                                    <div className="comment-review star-rating" key={"ten-" + e}>
                                      <span className="review-text">
                                        <span>
                                          {data.type} Ticket:
                                        </span> Rs.{data.price}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default EventDetails;
